import { Line, LineChart, ResponsiveContainer } from "recharts";
import { useOtterfolioSparkline } from "../../hooks/otterfolio";
import { OTTERFOLIO_THEME } from "./theme";

interface Props {
  positionId: string;
  trend: "pos" | "neg";
}

export function PositionTileSparkline({ positionId, trend }: Props) {
  const { data } = useOtterfolioSparkline(positionId, 30);
  if (!data || data.points.length < 2) {
    return (
      <div
        style={{
          height: 20,
          background: OTTERFOLIO_THEME.cardBg,
          border: `1px solid ${OTTERFOLIO_THEME.cardBorder}`,
          borderRadius: 3,
          opacity: 0.4,
        }}
      />
    );
  }
  const stroke = trend === "pos" ? OTTERFOLIO_THEME.primary : OTTERFOLIO_THEME.highlight;
  return (
    <div style={{ height: 20, width: "100%" }}>
      <ResponsiveContainer>
        <LineChart data={data.points}>
          <Line
            type="monotone"
            dataKey="priceEurCents"
            stroke={stroke}
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
